import {DDR} from './ddr.class';

export class DDRWoman913Strategy extends DDR {
  constructor() {
    super([600, 5, 11, 60, 45, 0.9, 0.9, 12, 1.0, 300, 1.8, 4, 20, 375, 1300, 21, 700, 2, 120, 8, 240, 1.6, 1250, 40, 8]);
  }
}
